export const KEY_SESSION = 'SESSION';
export const ACTIVE_QUOTE = 'ACTIVE_QUOTE';
export const ACTIVE_CREDIT = 'ACTIVE_CREDIT';

class SessionManager {
    setSession(session) {
        localStorage.setItem(KEY_SESSION, JSON.stringify(session));
    }
    getSession() {
        return JSON.parse(localStorage.getItem(KEY_SESSION));
    }
    unsetSession() {
        localStorage.removeItem(KEY_SESSION);
        this.unsetQuote();
    }
    getUser() {
        return this.getSession().user;
    }
    setQuoteState(quote) {
        sessionStorage.setItem(ACTIVE_QUOTE, JSON.stringify(quote));
    }
    getQuoteState() {
        return JSON.parse(sessionStorage.getItem(ACTIVE_QUOTE));
    }
    setCreditState(credit) {
        sessionStorage.setItem(ACTIVE_CREDIT, JSON.stringify(credit));
    }
    getCreditState() {
        return JSON.parse(sessionStorage.getItem(ACTIVE_CREDIT));
    }
    unsetQuote() {
        sessionStorage.removeItem(ACTIVE_QUOTE);
    }
}

const sessionManager = new SessionManager();
export default sessionManager;



// WEBPACK FOOTER //
// ./src/app/Managers/SessionManager.js